export default __webpack_public_path__ + "static/media/image_new_zealand.9cc82a25.png";